<template>
  <Component :is="tag" @contextmenu.stop.prevent="onContextMenu">
    <slot />
    <Teleport to="body">
      <Transition name="bk-context-menu">
        <ContextMenuMenu
          v-if="isVisible"
          :menu="menu"
          :x="x"
          :y="y"
          @close="ui.openContextMenu.value = ''"
        />
      </Transition>
    </Teleport>
  </Component>
</template>

<script setup>
import { ref, computed, useBlokkli } from "#imports";
import ContextMenuMenu from "./Menu/index.vue";
const props = defineProps({
  id: { type: String, required: true },
  menu: { type: Array, required: true },
  tag: { type: String, required: false, default: "div" }
});
const { ui } = useBlokkli();
const isVisible = computed(() => ui.openContextMenu.value === props.id);
const x = ref(0);
const y = ref(0);
const onContextMenu = (e) => {
  if (!props.id || typeof props.id !== "string" || !props.menu.length) {
    return;
  }
  x.value = e.clientX;
  y.value = e.clientY;
  ui.openContextMenu.value = props.id;
};
</script>
